export default "__VITE_ASSET__DtP7BvPG__"